import { render, staticRenderFns } from "./AddEditServiceForm.vue?vue&type=template&id=5177761b&scoped=true"
import script from "./AddEditServiceForm.vue?vue&type=script&lang=js"
export * from "./AddEditServiceForm.vue?vue&type=script&lang=js"
import style0 from "./AddEditServiceForm.vue?vue&type=style&index=0&id=5177761b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5177761b",
  null
  
)

export default component.exports